/*

Calculation List

*/

import React, { useContext, useEffect, useState } from "react";
import InputTextSimple from "../../../../components/common/InputText/InputTextSimple";
import ButtonOutline from "../../../../components/common/buttons/ButtonOutlineWithIcon";
import PlusIcon from ".//..//..//..//..//assets//images//icons//plus.svg";
import DropDown from "./DropDown";
import DataTable from "react-data-table-component";
import ConditionLabel from "../../../../components/calculator/ConditionLabel/ConditionLabel";
import { Link, useNavigate } from "react-router-dom";
import { ROUTES } from "../../../../constants/Routes";
import { AuthContext } from "../../../../context/AuthContext";
import HttpHelper from "../../../../helpers/Http/HttpHelper";
import { API_ROUTES } from "../../../../constants/API_ROUTES";
import useAuth from "../../../../hooks/useAuth";
import { toast } from "react-toastify";

const KalkulacioList = () => {
  const [calCount, setCalCount] = useState("");
  const [spinnerVisible, setSpinnerVisible] = useState("");
  const { getAuth, clearAuth } = useAuth();
  const navigate = useNavigate();

  const handleRowClicked = (row) => {
    const sorszama = row["id"];
    const osszeg = row["osszeg"];

    if (osszeg.trim() == "-") {
      navigate(`${ROUTES.CAL_MANAGE_CUSTOMER_DATA}?p-id=${sorszama}`, {
        state: {
          sorszama: sorszama,
        },
      });
    } else {
      navigate(`${ROUTES.CAL_DATA_SHEET}?p-id=${sorszama}`, {
        state: {
          sorszama: sorszama,
        },
      });
    }
  };

  const customStyles = {
    rows: {
      style: {
        minHeight: "40px",
        background: "#eee",
        marginTop: "0.625rem",
        marginBottom: "0.625rem",
        borderRadius: "1rem",
        border: 0,
        cursor: "pointer",
        boxShadow: "0px 4px 4px 0px rgba(16, 16, 16, 0.10)",
      },
    },

    headCells: {
      style: {
        paddingLeft: "1rem",
        paddingRight: "1rem",
      },
    },
    cells: {
      style: {
        paddingLeft: "1rem",
        paddingRight: "1rem",
      },
    },
  };

  const columns = [
    {
      name: "Sorszáma",
      selector: (row) => row.sorszama,
    },
    {
      name: "Ügyfél neve",
      selector: (row) => row.ugyfel_neve,
    },
    {
      name: "Felpakolási hely",
      selector: (row) => row.felpakolasi_hely,
    },
    {
      name: "Telefonszám",
      selector: (row) => row.telefonszam,
    },
    {
      name: "Típus",
      selector: (row) => row.tipus,
    },
    {
      name: "Összeg",
      selector: (row) => row.osszeg,
    },
    {
      name: "Állapot",
      selector: (row) => row.allapot,
    },
  ];

  const [proposalList, setProposalList] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedProposalTypes, setSelectedProposalTypes] = useState([]);

  const fetchProposals = () => {
    setSpinnerVisible(true);
    HttpHelper.PostRequest({
      route: `${API_ROUTES.PR_LIST}`,
      token: getAuth()?.bearerToken,
      parameters: {
        searchQuery,
        proposalType: selectedProposalTypes,
      },
    })
      .then((data) => {
        if (data.status == 200) {
          const proposals = data?.data?.proposals;
          console.info(proposals);
          const updatedProposalList = proposals.map((proposal, index) => {
            return {
              id: proposal?.id,
              sorszama: proposal?.proposal_number,
              ugyfel_neve: proposal?.keresztnev + proposal?.vezeteknev,
              felpakolasi_hely: proposal?.cim,
              telefonszam: proposal?.telefonszam,
              tipus: proposal?.proposal_type,
              osszeg: `${proposal?.osszesen == null ? "-" : proposal?.osszesen + " EUR"}`,
              allapot:
                proposal?.status == 0 ? (
                  <ConditionLabel condition={"FOLYAMATBAN"} />
                ) : (
                  <ConditionLabel condition={"BEFEJEZETT"} />
                ),
            };
          });

          setProposalList(updatedProposalList);

          setSpinnerVisible(false);
        } else if (data.status == 401) {
          clearAuth();
          navigate(ROUTES.AUTH);
        } else if (data.status == 500) {
          toast.error("Error, Server Error !", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setSpinnerVisible(false);
        } else {
          toast.error("Unknown server error!", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setSpinnerVisible(false);
        }
      })
      .catch((err) => {
        clearAuth();
        navigate(ROUTES.AUTH);
        // toast.error("Unknown server error!", {
        //   position: "top-right",
        //   autoClose: 2000,
        //   hideProgressBar: false,
        //   closeOnClick: true,
        //   pauseOnHover: true,
        //   draggable: true,
        //   progress: undefined,
        //   theme: "light",
        // });
        setSpinnerVisible(false);
      });
  };

  const proposalFilterHandler = (givenValue) => {
    const isValuePresent = selectedProposalTypes.includes(givenValue);

    // Update state based on whether the value is present or not
    if (isValuePresent) {
      // Value is present, so remove it
      const updatedServices = selectedProposalTypes.filter((service) => service !== givenValue);
      setSelectedProposalTypes(updatedServices);
    } else {
      // Value is not present, so push it
      setSelectedProposalTypes((prevServices) => [...prevServices, givenValue]);
    }
  };

  useEffect(() => {
    fetchProposals();
  }, [searchQuery, selectedProposalTypes]);

  useEffect(() => {
    console.log(selectedProposalTypes);
  }, [selectedProposalTypes]);

  return (
    <>
      <div className="px-[1rem] sm:px-[1.875rem] mt-[3rem]">
        <h2 className="font-bold font-lato text-[2rem] sm:text-[3.125rem] leading-normal">{calCount} kalkuláció</h2>
        {/* Header Start */}
        <div className="mt-[3rem] flex flex-col lg:flex-row  justify-between gap-4 ">
          <div className="w-full md:w-1/4">
            <InputTextSimple
              placeholder={`Kalkuláció keresése`}
              variant="bold"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
          <div className="flex items-center gap-[1.125rem] ">
            <DropDown selectedProposalTypes={selectedProposalTypes} proposalFilterHandler={proposalFilterHandler} />
            <Link to={ROUTES.CAL_MANAGE_CUSTOMER_DATA_CREATE}>
              <ButtonOutline label={`Új`} icon={PlusIcon} />
            </Link>
          </div>
        </div>
        {/* Header End */}

        {/* Table Start */}
        <div className="mt-[3rem] w-full  ">
          <DataTable
            columns={columns}
            data={proposalList}
            onRowClicked={handleRowClicked}
            customStyles={customStyles}
          />
        </div>
        {/* Table End */}
      </div>
    </>
  );
};

export default KalkulacioList;
